module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_iterators.js
// module id = 229
// module chunks = 1